// Match Smooche's daily timer: midnight in the visitor's timezone, HH:MM:SS.
(() => {
  function update(){
    const now=new Date(),end=new Date();end.setHours(24,0,0,0);
    const left=Math.max(0,Math.floor((end-now)/1000));
    const text=[Math.floor(left/3600),Math.floor(left%3600/60),left%60].map(x=>String(x).padStart(2,'0')).join(':');
    document.querySelectorAll('[data-offer-countdown]').forEach(e=>e.textContent=text);
  }
  update();setInterval(update,1000);document.addEventListener('visibilitychange',update);
})();
